/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GetModuleWorkingModeDiffTarget } from './getModuleWorkingModeDiffTarget';

export type GetModuleWorkingModeDiffParams = {
  /**
   * Proposed working mode to diff against current module state
   */
  target: GetModuleWorkingModeDiffTarget;
};
